import { render, staticRenderFns } from "./dashboard-container.vue?vue&type=template&id=74dba18e"
import script from "./dashboard-container.vue?vue&type=script&lang=js"
export * from "./dashboard-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74dba18e')) {
      api.createRecord('74dba18e', component.options)
    } else {
      api.reload('74dba18e', component.options)
    }
    module.hot.accept("./dashboard-container.vue?vue&type=template&id=74dba18e", function () {
      api.rerender('74dba18e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/client-portal/js/modules/dashboard/components/dashboard-container.vue"
export default component.exports